module.exports = __webpack_public_path__ + "media/images/emblems/Muriaux-Blazono-aed07af190cb911a926d3e252392181d.png";